<div class="card">
    <div class="cardTitle">
        <h2>{{ 'dashboard.scheduledReports.emailSettings.label' | translate }}</h2>
    </div>

    <div class="cardContent">
        <div class="infoNotification">
            <i class="fa-solid fa-circle-info"></i>
            <span class="label">{{ 'dashboard.scheduledReports.emailSettings.info' | translate }}</span>
        </div>
        @if (form) {
            <form [formGroup]="form">
                <div class="inputGroup">
                    <label for="subject">{{ 'dashboard.scheduledReports.emailSettings.subject' | translate }}</label>
                    <input id="subject" type="text" formControlName="subject" />
                </div>
                <div class="inputGroup">
                    <label for="body">{{ 'dashboard.scheduledReports.emailSettings.body' | translate }}</label>
                    <textarea id="body" type="text" formControlName="body"></textarea>
                </div>
            </form>
        }
    </div>

    <div class="cardFooter">
        <button type="button" class="button primary icon" (click)="closeModal(true)">
            <i class="far fa-save"></i>
            <span>{{ 'generalKeywords.save' | translate }}</span>
        </button>
        <button type="button" class="button" (click)="closeModal(false)">
            <span>{{ 'generalKeywords.cancel' | translate }}</span>
        </button>
        <button type="button" class="button reset icon" (click)="resetForm()">
            <i class="far fa-refresh"></i>
            <span>{{ 'generalKeywords.reset' | translate }}</span>
        </button>
    </div>
</div>
